import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=a50f5f4a&scoped=true&"
import script from "./Verification.vue?vue&type=script&lang=js&"
export * from "./Verification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50f5f4a",
  null
  
)

export default component.exports